var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('card',[_c('h1',[_c('i',{staticClass:"tim-icons icon-alert-circle-exc"}),_vm._v(" 404")]),_c('p',[_vm._v("The page you requested could not be found.")])])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }